import { defineService } from '@wix/services-manager/helpers'
import type { ServiceDefinition } from '@wix/services-manager/types'
import type { ContextBindingConfig } from '@wix/thunderbolt-becky-types'
import type { InnerElementBindingsDescriptor } from '../types'

export interface IContextBindingService {
	getBindings: (compId: string) => Array<ContextBindingConfig>
	getInnerElementsBindings: (compId: string) => Array<InnerElementBindingsDescriptor>
	subscribeToBindingChanges: (compId: string, callback: () => void) => () => void
}

export type IContextBindingServiceConfig = {
	compIdToBindingMap: {
		[compId: string]: Array<ContextBindingConfig>
	}
	compIdToInnerElementsBindingMap: {
		[compId: string]: Array<InnerElementBindingsDescriptor>
	}
}

export type IContextBindingServiceDefinition = ServiceDefinition<IContextBindingService, IContextBindingServiceConfig>

export const ContextBindingServiceDefinition = defineService<IContextBindingService, IContextBindingServiceConfig>(
	'feature-builder-context-providers/context-binding-service'
)
